// Libraries
import 'bootstrap';

// Global components
import './Components/MainNavigationClass';
import './Components/ScrollToClass';
import './Components/ToTopButtonClass';
import './Components/SliderClass';
import './Components/LightboxClass';
import './Components/LightboxContentClass';
import './Components/AudioplayerClass';
import './Components/ImageGalleryClass';
import './Components/FiveQuestionsClass';
import './Components/TopicQuiz';
import './Components/FrequencyFinderClass';
import './Components/TextmediaImageClass';
import './Components/MultiSelectClass';
import './Components/AccordionClass';
import './Components/PopoverClass';
import './Components/SearchListClass';
import {ImagePreview} from './Components/ImagePreviewClass'
import {Popover} from "./Components/PopoverClass";
import {Accordion} from "./Components/AccordionClass";
import {NewsAutoReload} from "./Components/NewsAutoReloadClass";

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('[data-popover]').forEach(el => {
        new Popover(el);
    });

    document.querySelectorAll<HTMLElement>('[data-image-overlay]').forEach(el => {
        new ImagePreview(el);
    });

    document.querySelectorAll<HTMLElement>('[data-accordion]').forEach(accordion => {
        new Accordion(accordion);
    });

    document.querySelectorAll<HTMLInputElement>('[data-news-auto-reload]').forEach(newsToggle => {
        new NewsAutoReload(newsToggle);
    });

    document.querySelectorAll<HTMLElement>('.privacymanager').forEach(trigger => {
        trigger.addEventListener('click', function(event){
            event.preventDefault();
            // @ts-ignore
            if (window.UC_UI instanceof Object) {
                // @ts-ignore
                window.UC_UI.showFirstLayer();
            } else {
                console.error('window.UC_UI not loaded!');
            }
            return false;
        });
    })
});
